<template>

    <button
      class="btn btn-link nav-link px-0 px-lg-2 py-2 dropdown-toggle d-flex align-items-center"
      id="bd-theme"
      type="button"
      aria-expanded="false"
      @click="toggleDropdown"
    >
      <span
        data-bs-toggle="tooltip"
        data-bs-html="true"
        data-bs-title="<em>Tema</em> <b>Color</b>"
        class="d-flex align-items-center justify-content-center theme-icon-container"
      >
        <i :class="activeIconClass" aria-hidden="true"></i>
      </span>
      <span class="d-lg-none ms-2" id="bd-theme-text">{{ currentThemeLabel }}</span>
    </button>

    <ul
      class="dropdown-menu dropdown-menu-end"
      aria-labelledby="bd-theme"
      :class="{ show: dropdownOpen }"
      @click.away="closeDropdown"
    >
      <li v-for="option in themeOptions" :key="option.value">
        <button
          type="button"
          class="dropdown-item d-flex align-items-center"
          :class="{ active: currentTheme === option.value }"
          @click="setAndShowTheme(option.value)"
        >
          <i :class="option.iconClass + ' me-2 opacity-75'" aria-hidden="true"></i>
          {{ option.label }}
          <i v-if="currentTheme === option.value" class="fa-solid fa-check ms-auto"></i>
        </button>
      </li>
    </ul>

</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const themeOptions = [
    { value: 'light', label: 'Light', iconClass: 'fa-solid fa-cloud-sun bi me-2  theme-icon' },
    { value: 'dark', label: 'Dark', iconClass: 'fa-solid fa-cloud-moon bi me-2  theme-icon' },
    { value: 'auto', label: 'Auto', iconClass: 'fa-solid fa-circle-half-stroke bi me-2  theme-icon' }
  ];

const currentTheme = ref('');
const activeIconClass = ref('fa-solid fa-cloud-sun');
const currentThemeLabel = ref('');
const dropdownOpen = ref(false);

const getStoredTheme = () => localStorage.getItem('theme');
const setStoredTheme = (theme) => localStorage.setItem('theme', theme);

const setTheme = (theme) => {
  const root = document.documentElement;
  if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    root.setAttribute('data-bs-theme', 'dark');
  } else {
    root.setAttribute('data-bs-theme', theme);
  }
};

const showActiveTheme = (theme) => {
  currentTheme.value = theme;
  const matchedOption = themeOptions.find(option => option.value === theme);
  if (matchedOption) {
    activeIconClass.value = matchedOption.iconClass + ' theme-icon';
    currentThemeLabel.value = matchedOption.label;
  }
  setStoredTheme(theme);
  setTheme(theme);
};

const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value;
};

const closeDropdown = () => {
  dropdownOpen.value = false;
};

const setAndShowTheme = (theme) => {
  showActiveTheme(theme);
  closeDropdown();
};

onMounted(() => {
  const preferredTheme = getStoredTheme() || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  showActiveTheme(preferredTheme);
});

</script>

<style scoped lang="scss">
.theme-icon-container {
  width: 1.5rem;
  height: 1.5rem;
}
.theme-icon {
  font-size: 1.25rem;
}
.dropdown-item.active {
  font-weight: 600;
}
</style>
